const SORT_STATES = ['asc', 'desc']

export const getNextSortValue = (sortOption, field) => {
  if (sortOption.sortField !== field) {
    return SORT_STATES.at(0)
  }

  const currentIndex = SORT_STATES.indexOf(sortOption.sortValue)
  return currentIndex === SORT_STATES.length - 1 ? null : SORT_STATES[currentIndex + 1]
}
